// @flow
import type {
  CabelasClassFormValues,
  EventVenue,
} from "redux/modules/createCabelasClass/parsers/form";

export type TypedAddress = {
  venueName?: string,
  address1?: string,
  address2?: string,
  city?: string,
  state?: string,
  postalCode?: string,
  lat?: number | string,
  lng?: number | string,
};

export type ChapterEventFormValues = CabelasClassFormValues & {
  useTypedAddress?: boolean,
  typedAddress?: TypedAddress,
};

// Matches the events API's State rule.
const STATE_CODES: Array<string> = (
  "AL AK AZ AR CA CO CT DE DC FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS " +
  "MO MT NE NV NH NJ NM NY NC ND OH OK OR PA PR RI SC SD TN TX UT VT VI VA WA " +
  "WV WI WY AA AE AP"
).split(" ");

const trimmed = (value: ?string): string => (value || "").trim();

export const getTypedAddressErrors = (
  address: ?TypedAddress
): { [string]: string } => {
  const errors = {};
  if (!trimmed(address?.address1)) {
    errors.address1 = "Required";
  }
  if (!trimmed(address?.city)) {
    errors.city = "Required";
  }
  if (!STATE_CODES.includes(trimmed(address?.state).toUpperCase())) {
    errors.state = "Enter a two-letter state code";
  }
  if (!/^[0-9]{5}(?:-[0-9]{4})?$/.test(trimmed(address?.postalCode))) {
    errors.postalCode = "Enter a 5-digit ZIP code";
  }
  return errors;
};

export const parseTypedAddress = (address: ?TypedAddress): EventVenue => {
  const lat = parseFloat(String(address?.lat));
  const lng = parseFloat(String(address?.lng));
  if (
    !address ||
    Object.keys(getTypedAddressErrors(address)).length ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lng)
  ) {
    throw new Error("Enter an event address that can be found on the map.");
  }
  const address2 = trimmed(address.address2);
  const venueName = trimmed(address.venueName);
  return {
    address: {
      address1: trimmed(address.address1),
      ...(address2 ? { address2 } : {}),
      city: trimmed(address.city),
      state: trimmed(address.state).toUpperCase(),
      postalCode: trimmed(address.postalCode),
      ...(venueName ? { venueName } : {}),
    },
    coordinates: { lat: String(lat), lng: String(lng) },
  };
};
